// removed by extract-text-webpack-plugin
module.exports = {"container":"_2wgyrKUtxWXaSIt2jt3wLa","overlay":"_3lwydn074qjpWL-yZAypD8","header":"_1YrUEcOO147pihWfYfuXeV","text":"_2r310A9PWf4Gt7Y6mUwPxs","info":"PjdLTZDXtAg_xDiRvcb6Q","scrollingArea":"_2vWkjOhgOerb2NRTmQtvN8","closeButton":"_1K_OBvqqFgwD3ewoFSa8hp","spinner":"_2BqhrCHz_r40bebBlthhKI"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/CheckoutHelp/style.scss
// module id = 868
// module chunks = 0